module.exports = __webpack_public_path__ + "img/send2_select.3e4f1801.png";